import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import USER_AUTH from "queries/userAuth.gql";
import { logGqlErrorToSentry } from "utils/sentry";
import SIGNUP_USER from "../queries/signupUser.gql";

const useFindOrCreateUser = () => {
  const [user, setUser] = useState();
  const [gqlError, setGqlError] = useState();
  const [loading, setLoading] = useState();

  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [requiresNewUser, setRequiresNewUser] = useState(false);
  const [inputData, setInputData] = useState(false);

  const [signupMutation, { loading: signUpLoading }] = useMutation(SIGNUP_USER, {
    errorPolicy: "all",
  });

  const [findOrCreateUser, { error, loading: userAuthLoading }] = useLazyQuery(
    USER_AUTH,
    {
      errorPolicy: "all",
      onCompleted(data) {
        if (data?.viewer) {
          setUser(data?.viewer);
          setUserLoggedIn(true);
        } else {
          setRequiresNewUser(true);
        }
        setLoading(false);
      },
    },
  );

  useEffect(() => {
    if (error?.graphQLErrors?.length) {
      logGqlErrorToSentry(error.graphQLErrors[0], "Onboarding: Failed to find/create user", {
        storage_data: JSON.parse(localStorage.getItem("onBoarding")) ?? [],
        form_data: inputData,
      });
      setGqlError(error.graphQLErrors[0]);
    }
  }, [error, inputData]);

  useEffect(() => {
    if (requiresNewUser) {
      signupMutation({
        variables: {
          input: inputData,
        },
      })
        .then((result) => {
          if (result.errors?.length) {
            logGqlErrorToSentry(result.errors[0], "Onboarding: Failed to signup user", {
              storage_data: JSON.parse(localStorage.getItem("onBoarding")) ?? [],
              form_data: inputData,
            });
            setGqlError(result.errors[0]);

            return;
          }

          setUserLoggedIn(true);
          setUser(result.data?.signup?.user);
          setUserLoggedIn(true);
          setRequiresNewUser(false);
          setLoading(false);
        });
    }
  }, [requiresNewUser, signupMutation, inputData]);

  useEffect(() => {
    if (userAuthLoading || signUpLoading) {
      setLoading(true);
    }
    return () => {
      setLoading(false);
    };
  }, [userAuthLoading, signUpLoading]);

  return {
    findOrCreateUser: (userData) => {
      setInputData(userData);
      findOrCreateUser();
    },
    user,
    userLoggedIn,
    error: gqlError,
    loading,
  };
};

export default useFindOrCreateUser;
